const OpenTok = require('opentok');

export const apiKey = '47050874';
// export const sessionId = "2_MX40NzA1MDg3NH5-MTYwODIyNTE1MjYzNn5Fa3N1QmpnbFdnT3gvTWVTb3FxNksvZS9-fg";

const sessionIdCode = '2_MX40NzA1MDg3NH5-';

export const sessionId = sessionIdCode;
// export const token = "T1==cGFydG5lcl9pZD00NzA1MDg3NCZzaWc9N2U3MDI0MTk3NzZjZTk1NmQ2MjljMTJjMDIxMjVkNDBhODdkOTAzYTpzZXNzaW9uX2lkPTJfTVg0ME56QTFNRGczTkg1LU1UWXdPREl5TlRFMU1qWXpObjVGYTNOMVFtcG5iRmRuVDNndlRXVlRiM0Z4TmtzdlpTOS1mZyZjcmVhdGVfdGltZT0xNjA4MjI1MTgwJm5vbmNlPTAuODgwNzc2MDM2ODIzMzQ1JnJvbGU9cHVibGlzaGVyJmV4cGlyZV90aW1lPTE2MTA4MTcxODYmaW5pdGlhbF9sYXlvdXRfY2xhc3NfbGlzdD0=";

const projectSecret = 'bcfa1ff92738adb50f18152146a945f074747483';

var openTok = new OpenTok(apiKey, projectSecret);

export function generatedAdminToken(callback, sessionIdSecond) {
	var token;
	openTok.createSession({}, function (error, session) {
		if (error) {
			console.log('Error creating session: ', error);
		} else {
			var tokenOptions = {};
			tokenOptions.role = 'moderator';

			token = openTok.generateToken(sessionId + sessionIdSecond, tokenOptions);
			callback(token);
		}
	});
	return token;
}
